var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"gameContainer"}},[_c('toolbar'),_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('game-column',{staticClass:"gameLeft",attrs:{"cols":"6","side":'left'}}),_c('game-column',{staticClass:"gameRight",attrs:{"cols":"6","side":'right'}})],1),_c('keyboard'),_c('clock'),_c('complete-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }